import { IItemCache } from '../IItemCacheObserver';
import { getItemKey } from './getItemKey';
import { getPreferredItemKey } from './getPreferredItemKey';

export function haveSameParentItem(itemCache: IItemCache, props: {
  itemKey1: string | undefined;
  itemKey2: string | undefined;
}): boolean {
  const parentItemKey1 = getItemKey(itemCache, { itemKey: props.itemKey1 });
  const parentItemKey2 = getItemKey(itemCache, { itemKey: props.itemKey2 });

  const preferredItemKey1 = getPreferredItemKey(itemCache, { itemKey: parentItemKey1 });
  const preferredItemKey2 = getPreferredItemKey(itemCache, { itemKey: parentItemKey2 });

  return preferredItemKey1 === preferredItemKey2;
}
